// import { getChannelSummary } from '@redux/config/actions';
import sumBy from 'lodash/sumBy';
import orderBy from 'lodash/orderBy';
import { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button, Card, Col, Collapse } from 'antd';
import { fromPairs, groupBy, reduce, upperFirst, values } from 'lodash';
// import { AlignLeftOutlined, RightOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from '@redux';
import { DynamicObjectType } from 'types/commons';
// import { CHANNEL_FAKE } from './channelSumFake';
import { getSummaryOrderDelivery } from '@redux/config/actions';
import { AlignLeftOutlined, RightOutlined } from '@ant-design/icons';
import { useGetFilter } from 'hooks/useSearchParamsObj';

interface IChannelFilterProps {
  isPending?: boolean;
  fulfillmentPartner?: string;
  customApiResource?: string;
  resource?: string;
  onFilter?: (data: any) => void;
  status?: string;
  hasMergeWebsiteWithMiniApp?: boolean;
  isShowFixed?: boolean;
}

const { Panel } = Collapse;

const getShippingType = (shippingType) => {
  if (['click&collect', 'in3Days', 'in1Day', 'in2h'].includes(shippingType))
    return `orders.shippingType.${shippingType}`;
  return shippingType;
};

const ChannelFilter = ({
  // isPending,
  fulfillmentPartner,
  // customApiResource,
  // resource = 'orders',
  onFilter,
  status,
  hasMergeWebsiteWithMiniApp = false,
  isShowFixed = false,
}: IChannelFilterProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { searchParams, setSearchParams, filter } = useGetFilter();

  const [visible, setVisible] = useState(false);
  const channelSummary = useSelector<DynamicObjectType[]>(
    (state) => state.config.summaryOrderDelivery,
  );
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    dispatch(
      getSummaryOrderDelivery({
        data: {
          status: status,
        },
      }),
    );
  }, [status, fulfillmentPartner]);

  const channelSummaries = useMemo(() => {
    const summaries: DynamicObjectType = {
      website: {
        channel: 'website',
        value: [],
        count: 0,
      },
    };

    channelSummary?.forEach((e) => {
      if (
        ['momo_miniapp', 'website'].includes(e.channel) &&
        hasMergeWebsiteWithMiniApp
      ) {
        const value = reduce(
          groupBy(
            orderBy(
              [...summaries.website.value, ...e.value].map((item) => {
                const title = `${item?.chainStoreId}
                ${
                  item?.carrierName || item?.carrierId
                    ? ` - ${item?.carrierName || item?.carrierId}`
                    : ''
                }
                ${
                  item?.shippingType
                    ? ` - ${t(getShippingType(item?.shippingType))}`
                    : ''
                }${item?.carrierName ? ` - ${item?.carrierName}` : ''}`;

                return {
                  ...item,
                  // is_has_lot_date: item?.is_has_lot_date || false,
                  shippingType: item?.shippingType || '',
                  title,
                  titleLength: title?.length,
                  itemKey: `${item?.channel}-${item?.chainStoreId}-${item?.shippingType}-${item?.carrierId}`,
                };
              }),
              ['chainStoreId', 'shippingType', 'titleLength', 'itemKey'],
              ['asc', 'asc'],
            ).map((e) => ({
              ...e,
              fakeId: `${e.chainStoreId}-${e.shippingType}`,
            })),
            'fakeId',
          ),
          (prev, curr) => {
            return [
              ...prev,
              {
                ...curr[0],
                channel: 'website',
                value:
                  curr.length === 2
                    ? [...(curr[0]?.value || []), ...(curr[1]?.value || [])]
                    : curr[0]?.value,
                count:
                  curr.length === 2
                    ? Number(curr[0]?.count) + Number(curr?.[1]?.count)
                    : Number(curr[0]?.count),
              },
            ];
          },
          [],
        );

        summaries.website = {
          ...e,
          value: value,
          count:
            sumBy(e?.value, function (o: DynamicObjectType) {
              return Number(o.count);
            }) + Number(summaries.website.count),
        };
      } else {
        summaries[e.channel] = {
          ...e,
          value: orderBy(
            e.value.map((item) => {
              const title = `${item?.chainStoreId}${
                item?.shippingType
                  ? ` - ${t(getShippingType(item?.shippingType))}`
                  : ''
              }${item?.carrierName ? ` - ${item?.carrierName}` : ''}
              `;

              return {
                ...item,
                // is_has_lot_date: item?.is_has_lot_date || false,
                shippingType: item?.shippingType || '',
                title,
                titleLength: title.length,
                count: Number(item?.count),
                itemKey: `${item?.channel}-${item?.chainStoreId}-${item?.shippingType}-${item?.carrierId}`,
              };
            }),
            ['chainStoreId', 'shippingType', 'titleLength', 'itemKey'],
            ['asc', 'asc'],
          ),
          count: sumBy(e?.value, function (o: DynamicObjectType) {
            return Number(o.count);
          }),
        };
      }
    });
    return values(summaries);
  }, [channelSummary, hasMergeWebsiteWithMiniApp]);

  const totalOrders = sumBy(
    channelSummary?.map((summary) => ({
      count: sumBy(summary?.value, function (c: DynamicObjectType) {
        return Number(c.count);
      }),
    })),
    function (sum: DynamicObjectType) {
      return Number(sum.count);
    },
  );

  const onChange = (e) => {
    const pressChannel = e.find((item) => !selected.includes(item));
    setSelected(e);
    pressChannel &&
      onFilter?.({
        channel: pressChannel,
      });
  };
  const currentSelectedByFilter = fromPairs(
    filter?.filters
      ?.filter((item) =>
        [
          'channel',
          'chainStoreId',
          'shippingCarrierId',
          'shippingType',
        ].includes(item?.key),
      )
      ?.map((i) => [i?.key, i?.operator === 'isnull' ? 'null' : i?.value]),
  );

  const content = (
    <ChannelFilterWrapper>
      <div className="flex justify-between items-center">
        <div
          className={`text-[--primary] cursor-pointer ${filter?.filters?.length > 0 ? '' : 'font-semibold'}`}
          role="presentation"
          onClick={() => {
            searchParams.delete('filters');
            setSearchParams(searchParams);
          }}
        >
          {t('orders.filters.all')}
        </div>
        <div className="bg-[#D5CFF3] rounded-[21px] text-[--primary] px-2.5 text-xs">
          {totalOrders || 0}
        </div>
      </div>
      <br />
      <Collapse onChange={onChange} expandIconPosition="end" bordered={false}>
        {channelSummaries?.map((summary, index) => (
          <Panel
            header={
              <div className="flex justify-between items-center mb-2.5">
                <div
                  className={`text-[--primary] ${currentSelectedByFilter?.channel === summary?.channel ? 'font-semibold' : ''}`}
                >
                  {upperFirst(summary?.channel)}
                </div>
                <div className="bg-[#D5CFF3] rounded-[21px] text-[--primary] px-2.5 text-xs">
                  {summary?.count || 0}
                </div>
              </div>
            }
            key={`${summary?.channel}`}
            // extra={
            //   <div className="bg-[#D5CFF3] rounded-[21px] text-[--primary] px-2.5 text-xs">
            //     {summary?.count || 0}
            //   </div>
            // }
            showArrow={false}
          >
            {summary?.value?.map((item, itemIndex) => (
              <div
                key={`item-${index}-${itemIndex}`}
                className={`filter-item mb-2.5 ml-2.5 pointer text-[--primary] text-xs
                 ${`${currentSelectedByFilter?.channel}-${currentSelectedByFilter?.chainStoreId}-${currentSelectedByFilter.shippingType || 'null'}-${currentSelectedByFilter?.shippingCarrierId}` === item?.itemKey && 'font-semibold'}
                  `}
                role="presentation"
                onClick={() => {
                  onFilter?.({
                    carrierId: item?.carrierId || {
                      isnull: true,
                    },
                    // ...(item?.is_has_lot_date && {
                    //   isHasLotDate: item?.is_has_lot_date,
                    // }),
                    ...(item?.shippingType && {
                      shippingType: item?.shippingType,
                    }),
                    ...(item?.channel && {
                      channel: item?.channel,
                    }),
                    ...(item?.chainStoreId && {
                      chainStoreId: item?.chainStoreId,
                    }),
                    ...(fulfillmentPartner && {
                      fulfillmentPartner,
                    }),
                    ...(item?.orderType && {
                      orderType: item?.orderType,
                    }),
                    // ...(item?.carrierId && {
                    //   shopId: item?.carrierId,
                    // }),
                    // ...(item?.is_market_place
                    //   ? {
                    //       isMarketPlace: true,
                    //       isMarketPlaceConfirmed:
                    //         item?.is_market_place_confirmed,
                    //     }
                    //   : {
                    //       isMarketPlace: false,
                    //     }),
                    // isPending: isPending || 'false',
                  });
                }}
              >
                <div className="text-xs">{upperFirst(item?.title)}</div>
                <div className="bg-[#D5CFF3] rounded-[21px] text-[--primary] px-2.5 text-xs">
                  {item?.count || 0}
                </div>
              </div>
            ))}
          </Panel>
        ))}
      </Collapse>
    </ChannelFilterWrapper>
  );

  return (
    <>
      {!isShowFixed && (
        <Col xs={0} md={5}>
          {content}
        </Col>
      )}
      {isShowFixed && (
        <PreviewChannelFilterStyle className={`${visible ? 'visible' : ''}`}>
          <Button
            icon={visible ? <RightOutlined /> : <AlignLeftOutlined />}
            shape="round"
            type="primary"
            size="large"
            className="preview-button"
            onClick={() => setVisible((old) => !old)}
          ></Button>
          <Card className={`product-preview ${visible ? 'visible' : ''}`}>
            {content}
          </Card>
        </PreviewChannelFilterStyle>
      )}
    </>
  );
};

const PreviewChannelFilterStyle = styled.div`
  position: fixed;
  top: 10vh;
  right: -250px;
  bottom: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 1s;
  width: 250px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: -18px 8px 20px 3px rgb(0 0 0 / 5%);
  z-index: 999;
  height: 80vh;
  .ant-card {
    height: 100%;
  }
  .ant-card-body {
    padding: 0px;
    overflow-x: auto;
    min-height: 80vh;
  }
  .preview-button {
    position: absolute;
    left: -30px;
    top: 30vh;
    z-index: 998;
    padding-left: 5px;
  }
  .product-preview {
    width: 100%;
    flex: 1;
    background-color: #fff;
    z-index: 999;
    border-radius: 10px;
    padding: 5px;
    overflow-y: scroll;
  }
  &.visible {
    right: 0px;
  }
`;

const ChannelFilterWrapper = styled.div`
  width: 100%;
  background: var(--bg-light);
  border: 1px solid #d7d5d5;
  border-radius: 10px;
  padding: 20px;

  .filter-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    transition: all 0.3s;
    &:hover {
      transform: translate(10px, 0px);
    }
  }

  .filter-value {
    font-size: 12px;
    background: #88c041;
    border-radius: 21px;
    color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 22px;
    font-weight: 600;
  }
  .ant-collapse {
    background-color: transparent;
  }
  .ant-collapse-item {
    border-bottom: none;
    .ant-collapse-header {
      padding: 0px;
    }
    .ant-collapse-content-box {
      padding: 0px;
    }
  }
`;

export default ChannelFilter;
